import React, { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    TextField,
    Typography,
    IconButton,
    MenuItem,
    Divider,
    Select,
    InputAdornment,
    LinearProgress,
    Paper

} from "@mui/material";
import { FaCalendarAlt, FaPaperclip } from "react-icons/fa";
import { FiUpload } from "react-icons/fi";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FaRegCalendarAlt } from "react-icons/fa";
import { LuDownload } from "react-icons/lu";
import { LuTrash2 } from "react-icons/lu";
import { IoAdd } from "react-icons/io5";
import { LuX } from "react-icons/lu";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";


function EditIssues({ open, onClose, data, }) {

    const [openStart, setOpenStart] = useState(false);
    const [files, setFiles] = useState([]);

    const handleFileUpload = (e) => {
        const now = new Date();
        const day = now.toLocaleString("en-GB", { day: "2-digit" });
        const month = now.toLocaleString("en-GB", { month: "short" });
        const year = now.getFullYear();
        const formattedDate = `${day} ${month}, ${year}`;

        const uploadedFiles = Array.from(e.target.files).map((file) => ({
            id: Date.now() + Math.random(),
            name: file.name,
            size: (file.size / 1024).toFixed(1) + " KB",
            date: formattedDate,
            type: file.name.split(".").pop().toUpperCase(),
            progress: 0,
            status: "uploading",
            error:
                file.size > 2 * 1024 * 1024
                    ? "The file is too large to upload."
                    : null,
        }));

        setFiles((prev) => [...prev, ...uploadedFiles]);


        formik.setFieldValue("isssueAttachFile", e.target.files[0]);

        uploadedFiles.forEach((file) => {
            if (file.error) return;

            const uploadInterval = setInterval(() => {
                setFiles((prevFiles) =>
                    prevFiles.map((f) =>
                        f.id === file.id
                            ? {
                                ...f,
                                progress: Math.min(f.progress + Math.floor(Math.random() * 15), 100),
                                status:
                                    f.progress + 15 >= 100 ? "uploaded" : "uploading",
                            }
                            : f
                    )
                );
            }, 300);

            setTimeout(() => clearInterval(uploadInterval), 4000);
        });
    };

    const handleRemoveFile = (id) => {
        setFiles((prev) => prev.filter((f) => f.id !== id));
        formik.setFieldValue("isssueAttachFile", null);
    };


    const labelTextStyle = {
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "-0.1px",
        color: "#5F5F5F",
        fontFamily: "Outfit, sans-serif",
        mb: 1,
        mt: 2.5,
    };
    const RightlabelTextStyle = {
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "100%",
        color: "#5F5F5F",
        fontFamily: "Outfit, sans-serif",
        pb: "8px"

    };

    const textStyle = {
        "& .MuiInputBase-input": {
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "100%",
            letterSpacing: "0.16px",
            color: "#0A0A0C",
            fontFamily: "Outfit, sans-serif",
        },
        "& .MuiInputBase-root": {
            height: "48px",
            border: "1px solid #ECECEC",
            borderRadius: "8px",
        }
    };

    const RightColTextStyle = {
        "& .MuiInputBase-input": {
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "100%",
            letterSpacing: "1%",
            color: "#0A0A0C",
            fontFamily: "Outfit, sans-serif",
            display: "flex",
            alignItems: "center",


        },
        "& .MuiInputBase-root": {
            height: "34px",
            border: "none",
            borderRadius: "5px",
            backgroundColor: "#E7E7EB",

        }
    };


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            contractor: "",
            category1: "",
            workflowStatus: "",
            subCategory2: "",
            subCategory3: "",
            currentStatus: "",
            issueDescription: "",
            actionRequiredBy: "",
            actionRequiredByEmail: "",
            timeImpact: "",
            costImpact: "",
            module: "",
            severity: "",
            reportedDate: "",
            workflow: "",
            isssueAttachFile: null

        },

        validationSchema: Yup.object({
            actionRequiredBy: Yup.string().required(
                "Action required by field is required."
            ),
            actionRequiredByEmail: Yup.string()
                .email()
                .required("Action required by Email field is required."),
            workflowStatus: Yup.string().required("workflow status is required"),
            module: Yup.string().required("Module field is required."),
            category1: Yup.string().required("Sub Category 1 field is required."),
            subCategory2: Yup.string().required("Sub Category 2 field is required."),
            subCategory3: Yup.string().required("Sub Category 3 field is required."),
            workflow: Yup.string().required("workflow  is required"),
            currentStatus: Yup.string().required("Current status field is required."),
            contractor: Yup.string().required("Contractor field is required."),
            severity: Yup.string().required("Severity field is required."),
            isssueAttachFile: Yup.mixed()
                .nullable()
                .test("fileType", "Only image files are allowed", (value) => {
                    if (!value) return true;
                    if (value instanceof File) {
                        return value.type.startsWith("image/");
                    }
                    if (typeof value === "string") {
                        return /\.(png|jpg|jpeg|svg|webp|gif|bmp|tiff)$/i.test(value);
                    }
                    return false;
                }),
            reportedDate: Yup.date()
                .required("Reporting Date is required")
                .nullable()
                .typeError("Reporting Date must be a valid date"),
            issueDescription: Yup.string().required(
                "Issue description field is required."
            ),
            timeImpact: Yup.number()
                // .positive()
                .integer()
                .required("Time Impact field is required."),
            costImpact: Yup.number()
                // .positive()
                .integer()
                .required("Cost Impact field is required."),
        }),
        onSubmit: async (values, formikHelpers) => {
            console.log("Issue Data", values)


            formikHelpers.resetForm()
            setFiles([]);
        },
    })

    return (
        <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            <Box sx={{ display: "flex", flexGrow: 1 }}>

                {/* Main Content */}
                <Box sx={{ flexGrow: 1, p: 3 }}>
            
                    {/* ---------- Popup Dialog ---------- */}
                    <Dialog
                        open={open}
                        onClose={onClose}
                        fullWidth
                        maxWidth="lg"
                        PaperProps={{
                            sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
                        }}
                    >
                        {/* Formik Form  */}
                        <form onSubmit={formik.handleSubmit}>
                            <DialogTitle
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    borderBottom: "1px solid #ddd",
                                    backgroundColor: "#ECECEC",
                                    pb: 2,
                                    pt: 3,
                                    width: "100%",
                                }}
                            >
                                <Box>
                                    <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                                        Edit an Issue
                                    </Typography>
                                    <Typography sx={{
                                        pt: 2, fontWeight: 400, fontSize: "14px", lineHeight: "100%", color: "#433F5E", fontFamily: "Outfit, sans-serif",
                                    }}>
                                        Edit an  issue form for your project
                                    </Typography>
                                </Box>

                            </DialogTitle>

                            <DialogContent sx={{ width: "100%", pt: 3, pb: 4, overflowX: "hidden", boxSizing: "border-box" }}>
                                <Grid container>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", md: "row" },
                                            gap: { xs: 2, md: 5 },
                                            width: "100%",
                                            boxSizing: "border-box",
                                            overflowX: "hidden",
                                        }}
                                    >
                                        <Grid size={{ xs: 12, md: 7 }}>
                                            {/* Left Side Inputs */}
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography sx={labelTextStyle}>
                                                    Action required by
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    placeholder="Enter action required by"
                                                    sx={textStyle}
                                                    name="actionRequiredBy"
                                                    value={formik.values.actionRequiredBy}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.actionRequiredBy && Boolean(formik.errors.actionRequiredBy)}
                                                    helperText={formik.touched.actionRequiredBy && formik.errors.actionRequiredBy}
                                                />

                                                <Typography sx={labelTextStyle}>
                                                    Action required by Email
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    placeholder="Enter email id "
                                                    type="email"
                                                    sx={textStyle}
                                                    name="actionRequiredByEmail"
                                                    value={formik.values.actionRequiredByEmail}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.actionRequiredByEmail && Boolean(formik.errors.actionRequiredByEmail)}
                                                    helperText={formik.touched.actionRequiredByEmail && formik.errors.actionRequiredByEmail}
                                                />

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: { xs: "column", sm: "row" },
                                                        gap: 2,
                                                    }}
                                                >

                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography sx={labelTextStyle}> Workflow Status</Typography>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            name="workflowStatus"
                                                            value={formik.values.workflowStatus}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.workflowStatus && Boolean(formik.errors.workflowStatus)}
                                                            helperText={formik.touched.workflowStatus && formik.errors.workflowStatus}
                                                            SelectProps={{
                                                                displayEmpty: true,
                                                            }}
                                                            sx={{
                                                                "& .MuiInputBase-input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    color: "#3F3F3F",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    display: "flex",
                                                                    alignItems: "center",


                                                                },
                                                                "& .MuiInputBase-root": {
                                                                    height: "48px",
                                                                    border: "1px solid #ECECEC",
                                                                    borderRadius: "6px",
                                                                    backgroundColor: "#E7E7EB",

                                                                }
                                                            }}
                                                        >
                                                            <MenuItem value="" disabled>Select workflow</MenuItem>
                                                            <MenuItem value="daily">Daily Check</MenuItem>
                                                            <MenuItem value="weekly">Weekly Inspection</MenuItem>
                                                        </TextField>
                                                    </Box>


                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography sx={labelTextStyle}>Module</Typography>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            name="module"
                                                            value={formik.values.module}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.module && Boolean(formik.errors.module)}
                                                            helperText={formik.touched.module && formik.errors.module}
                                                            SelectProps={{
                                                                displayEmpty: true,
                                                            }}
                                                            sx={{
                                                                "& .MuiInputBase-input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    color: "#3F3F3F",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    display: "flex",
                                                                    alignItems: "center",


                                                                },
                                                                "& .MuiInputBase-root": {
                                                                    height: "48px",
                                                                    border: "1px solid #ECECEC",
                                                                    borderRadius: "6px",
                                                                    backgroundColor: "#E7E7EB",

                                                                }
                                                            }}
                                                        >
                                                            <MenuItem value="" disabled>Select workflow</MenuItem>
                                                            <MenuItem value="daily">Daily Check</MenuItem>
                                                            <MenuItem value="weekly">Weekly Inspection</MenuItem>
                                                        </TextField>
                                                    </Box>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: { xs: "column", sm: "row" },
                                                        gap: 2,
                                                    }}
                                                >

                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography sx={labelTextStyle}>
                                                            Time Impact
                                                        </Typography>
                                                        <TextField
                                                            fullWidth
                                                            placeholder="Enter Time Impact in days"
                                                            sx={textStyle}
                                                            name="timeImpact"
                                                            value={formik.values.timeImpact}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.timeImpact && Boolean(formik.errors.timeImpact)}
                                                            helperText={formik.touched.timeImpact && formik.errors.timeImpact}
                                                        />
                                                    </Box>

                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography sx={labelTextStyle}>
                                                            Cost Impact
                                                        </Typography>
                                                        <TextField
                                                            fullWidth
                                                            placeholder="Enter Cost Impact in Rupees"
                                                            sx={textStyle}
                                                            name="costImpact"
                                                            value={formik.values.costImpact}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.costImpact && Boolean(formik.errors.costImpact)}
                                                            helperText={formik.touched.costImpact && formik.errors.costImpact}
                                                        />
                                                    </Box>

                                                </Box>
                                                <Typography sx={labelTextStyle}>
                                                    Current Satus
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    placeholder="Enter Current Status"
                                                    sx={textStyle}
                                                    name="currentStatus"
                                                    value={formik.values.currentStatus}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.currentStatus && Boolean(formik.errors.currentStatus)}
                                                    helperText={formik.touched.currentStatus && formik.errors.currentStatus}
                                                />

                                                <Typography sx={labelTextStyle}>
                                                    Issue Description
                                                </Typography>

                                                <TextField
                                                    fullWidth
                                                    placeholder="Write issue description in detail"
                                                    multiline
                                                    rows={4}
                                                    name="issueDescription"
                                                    value={formik.values.issueDescription}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.issueDescription && Boolean(formik.errors.issueDescription)}
                                                    helperText={formik.touched.issueDescription && formik.errors.issueDescription}
                                                    sx={{
                                                        ...textStyle,
                                                        "& .MuiInputBase-root": {
                                                            ...textStyle["& .MuiInputBase-root"],
                                                            height: "auto",
                                                            alignItems: "start",
                                                            backgroundColor: "#ECECEC"
                                                        },
                                                    }}
                                                />

                                            </Box>
                                        </Grid>

                                        {/* Right Side Inputs */}
                                        <Grid size={{ xs: 12, md: 5 }}>
                                            <Box sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "10px",
                                                marginTop: "20px"
                                            }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: { xs: "column", sm: "row" },
                                                        gap: "15px",
                                                    }}
                                                >
                                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                                        <Typography sx={RightlabelTextStyle}>
                                                            Reporting Date
                                                        </Typography>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <Box
                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        height: "34px",
                                                                        borderRadius: "5px",
                                                                        border: "none",
                                                                        backgroundColor: "#E7E7EB",
                                                                        "& fieldset": { border: "none" },
                                                                    },
                                                                    "& .MuiInputBase-input": {
                                                                        fontSize: "14px",
                                                                        fontWeight: 600,
                                                                        color: "#433F5E",
                                                                        lineHeight: "100%",
                                                                        padding: "2px 6px",
                                                                    },
                                                                    "& .MuiSvgIcon-root": {
                                                                        color: "#433F5E",
                                                                    },

                                                                }}
                                                            >
                                                                <DatePicker
                                                                    enableAccessibleFieldDOMStructure={false}
                                                                    open={openStart}
                                                                    onOpen={() => setOpenStart(true)}
                                                                    onClose={() => setOpenStart(false)}
                                                                    format="DD MMM, YYYY"
                                                                    value={
                                                                        formik.values.reportedDate
                                                                            ? dayjs(formik.values.reportedDate)
                                                                            : null
                                                                    }
                                                                    onChange={(newValue) => {
                                                                        formik.setFieldValue(
                                                                            "reportedDate",
                                                                            newValue ? newValue.format("YYYY-MM-DD") : ""
                                                                        );
                                                                    }}
                                                                    slots={{
                                                                        textField: (params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                name="reportedDate"
                                                                                placeholder="Start Date"
                                                                                error={
                                                                                    formik.touched.reportedDate &&
                                                                                    Boolean(formik.errors.reportedDate)
                                                                                }
                                                                                helperText={
                                                                                    formik.touched.reportedDate && formik.errors.reportedDate
                                                                                }
                                                                                sx={{}}
                                                                                InputProps={{
                                                                                    ...params.InputProps,
                                                                                    startAdornment: (
                                                                                        <InputAdornment position="start"
                                                                                            sx={{
                                                                                                marginRight: "-4px",
                                                                                            }}>

                                                                                            <IconButton
                                                                                                onClick={() => setOpenStart(true)}
                                                                                                edge="start"
                                                                                                size="small"
                                                                                                sx={{
                                                                                                    marginLeft: "0px",
                                                                                                }}
                                                                                            >
                                                                                                <FaRegCalendarAlt fontSize="16px" />
                                                                                            </IconButton>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                    endAdornment: null,
                                                                                }}
                                                                            />
                                                                        ),
                                                                    }}
                                                                />
                                                            </Box>
                                                        </LocalizationProvider>
                                                    </Box>

                                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                                        <Typography sx={RightlabelTextStyle}>Severity</Typography>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            name="severity"
                                                            value={formik.values.severity}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.severity && Boolean(formik.errors.severity)}
                                                            helperText={formik.touched.severity && formik.errors.severity}
                                                            sx={RightColTextStyle}
                                                            SelectProps={{
                                                                displayEmpty: true,
                                                            }}
                                                        >
                                                            <MenuItem value="">Select Severity</MenuItem>
                                                            <MenuItem value="low">Low</MenuItem>
                                                            <MenuItem value="medium">Medium</MenuItem>
                                                            <MenuItem value="high">High</MenuItem>
                                                        </TextField>
                                                    </Box>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: { xs: "column", sm: "row" },
                                                        gap: "15px",
                                                    }}
                                                >

                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography sx={RightlabelTextStyle}>Category</Typography>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            name="category1"
                                                            value={formik.values.category1}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.category1 && Boolean(formik.errors.category1)}
                                                            helperText={formik.touched.category1 && formik.errors.category1}
                                                            sx={RightColTextStyle}
                                                            SelectProps={{
                                                                displayEmpty: true,
                                                            }}
                                                        >
                                                            <MenuItem value="">Select category</MenuItem>
                                                            <MenuItem value="safety">Safety</MenuItem>
                                                            <MenuItem value="quality">Quality</MenuItem>
                                                        </TextField>

                                                    </Box>


                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography sx={RightlabelTextStyle}>Sub Category 1</Typography>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            name="subCategory2"
                                                            value={formik.values.subCategory2}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.subCategory2 && Boolean(formik.errors.subCategory2)}
                                                            helperText={formik.touched.subCategory2 && formik.errors.subCategory2}
                                                            sx={RightColTextStyle}
                                                            SelectProps={{
                                                                displayEmpty: true,
                                                            }}
                                                        >
                                                            <MenuItem value="">Select sub category 1</MenuItem>
                                                            <MenuItem value="electrical">Electrical</MenuItem>
                                                            <MenuItem value="mechanical">Mechanical</MenuItem>
                                                        </TextField>
                                                    </Box>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: { xs: "column", sm: "row" },
                                                        gap: "15px",
                                                    }}
                                                >

                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography sx={RightlabelTextStyle}> Slect Category 2</Typography>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            name="subCategory3"
                                                            value={formik.values.subCategory3}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.subCategory3 && Boolean(formik.errors.subCategory3)}
                                                            helperText={formik.touched.subCategory3 && formik.errors.subCategory3}
                                                            sx={RightColTextStyle}
                                                            SelectProps={{
                                                                displayEmpty: true,
                                                            }}
                                                        >
                                                            <MenuItem value="">Select sub category 2</MenuItem>
                                                            <MenuItem value="wiring">Wiring</MenuItem>
                                                            <MenuItem value="equipment">Equipment</MenuItem>
                                                        </TextField>
                                                    </Box>


                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography sx={RightlabelTextStyle}>WorkFlow</Typography>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            name="workflow"
                                                            value={formik.values.workflow}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.workflow && Boolean(formik.errors.workflow)}
                                                            helperText={formik.touched.workflow && formik.errors.workflow}
                                                            sx={RightColTextStyle}
                                                            SelectProps={{
                                                                displayEmpty: true,
                                                            }}
                                                        >
                                                            <MenuItem value="">Select workflow</MenuItem>
                                                            <MenuItem value="approval">Approval</MenuItem>
                                                            <MenuItem value="review">Review</MenuItem>
                                                        </TextField>
                                                    </Box>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: { xs: "column", sm: "row" },
                                                        gap: "15px",
                                                    }}
                                                >
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography sx={RightlabelTextStyle}>
                                                            Consultant/Contractor
                                                        </Typography>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            name="contractor"
                                                            value={formik.values.contractor}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.contractor && Boolean(formik.errors.contractor)}
                                                            helperText={formik.touched.contractor && formik.errors.contractor}
                                                            sx={RightColTextStyle}
                                                            SelectProps={{
                                                                displayEmpty: true,
                                                            }}
                                                        >
                                                            <MenuItem value="" >Select Contractor/Consultant</MenuItem>
                                                            <MenuItem value="ABC">ABC Constructions</MenuItem>
                                                            <MenuItem value="XYZ">XYZ Safety Ltd</MenuItem>
                                                        </TextField>
                                                    </Box>
                                                </Box>

                                                {/* Attachments Section */}
                                                <Box
                                                    sx={{
                                                        mt: 2,
                                                        border: "1px solid #ECECEC",
                                                        borderRadius: 1,
                                                        p: 2,
                                                        backgroundColor: "#FFFFFF",
                                                        width: "100%",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            mb: 1,
                                                        }}
                                                    >
                                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                                            <FaPaperclip color="#5B5772" />
                                                            <Typography
                                                                sx={{
                                                                    ml: 1,
                                                                    fontWeight: 500,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    color: "#433F5E",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                }}>
                                                                Attachments
                                                            </Typography>
                                                        </Box>

                                                        {files.length > 0 && (
                                                            <Box
                                                                onClick={() => document.getElementById("fileUploadInput").click()}
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    gap: "4px",
                                                                }}
                                                            >
                                                                <Typography

                                                                    sx={{
                                                                        fontSize: "14px",
                                                                        color: "#433F5E",
                                                                        fontWeight: 400,
                                                                        lineHeight: "100%",
                                                                    }}
                                                                >
                                                                    Add more
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        backgroundColor: "#ECECEC", // green
                                                                        borderRadius: "50%",
                                                                        width: 20,
                                                                        height: 20,
                                                                    }}
                                                                >
                                                                    <IoAdd size={14} color="#140F36" />
                                                                </Box>
                                                            </Box>
                                                        )}
                                                    </Box>

                                                    {/* Upload Box */}
                                                    {files.length === 0 && (
                                                        <Box
                                                            sx={{
                                                                mt: 1,
                                                                position: "relative",
                                                                borderRadius: "3px",
                                                                backgroundColor: "#ECECEC",
                                                                height: 100,
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                cursor: "pointer",
                                                                transition: "all 0.2s ease",
                                                                backgroundImage: `
                                                                                                repeating-linear-gradient(90deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px),   /* top */
                                                                                                repeating-linear-gradient(180deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px), /* right */
                                                                                                repeating-linear-gradient(90deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px),  /* bottom */
                                                                                                repeating-linear-gradient(180deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px)  /* left */
                                                                                                `,
                                                                backgroundRepeat: "no-repeat",
                                                                backgroundSize: "100% 1px, 1px 100%, 100% 1px, 1px 100%",
                                                                backgroundPosition: "top left, top right, bottom left, top left",
                                                            }}
                                                            onClick={() => document.getElementById("fileUploadInput").click()}
                                                        >
                                                            <input
                                                                type="file"
                                                                id="fileUploadInput"
                                                                hidden
                                                                multiple
                                                                onChange={handleFileUpload}
                                                            />
                                                            <Box
                                                                sx={{
                                                                    position: "relative",
                                                                    zIndex: 1,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    color: "#6B5FA4",
                                                                }}
                                                            >
                                                                <FiUpload color="#71839B" size={42} />
                                                                <Typography
                                                                    sx={{
                                                                        mt: 1,
                                                                        fontSize: "14px",
                                                                        fontWeight: 400,
                                                                        lineHeight: "100%",
                                                                        letterSpacing: "0.14px",
                                                                        color: "#71839B",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                    }}
                                                                >
                                                                    Upload attachment
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    )}

                                                    {/* Uploaded Files List */}
                                                    {files.length > 0 && (
                                                        <Box
                                                            sx={{
                                                                mt: 1,
                                                                maxHeight: files.length > 1 ? 145 : "none",
                                                                overflowY: files.length > 1 ? "auto" : "visible",
                                                                pr: files.length > 1 ? 1 : 0,
                                                                "&::-webkit-scrollbar": {
                                                                    width: "6px",
                                                                },
                                                                "&::-webkit-scrollbar-thumb": {
                                                                    backgroundColor: "#C1C1C1",
                                                                    borderRadius: "3px",
                                                                },
                                                            }}
                                                        >

                                                            <input
                                                                type="file"
                                                                id="fileUploadInput"
                                                                hidden
                                                                multiple
                                                                onChange={handleFileUpload}
                                                            />

                                                            {files.map((file) => (
                                                                <Box
                                                                    key={file.id}
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "flex-start",
                                                                        justifyContent: "space-between",
                                                                        p: 1,
                                                                        mt: 0.2,
                                                                        //borderBottom: "1px solid #E0E0E0",
                                                                    }}
                                                                >
                                                                    {/* File info */}
                                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                        <Box
                                                                            sx={{
                                                                                position: "relative",
                                                                                width: 24,
                                                                                height: 28,
                                                                                borderRadius: "1px",
                                                                                backgroundColor: "#E9F0FA",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "flex-end",
                                                                                fontWeight: 600,
                                                                                fontSize: "8px",
                                                                                color: "#FFFFFF",
                                                                                textTransform: "uppercase",
                                                                                fontFamily: "Outfit, sans-serif",
                                                                                overflow: "hidden",
                                                                                "&::before": {
                                                                                    content: '""',
                                                                                    position: "absolute",
                                                                                    top: 0,
                                                                                    right: 0,
                                                                                    borderTop: "10px solid #D0D5DD",
                                                                                    borderLeft: "10px solid transparent",
                                                                                    borderTopRightRadius: "4px",
                                                                                },
                                                                            }}
                                                                        >
                                                                            <Box
                                                                                sx={{
                                                                                    position: "absolute",
                                                                                    bottom: 4,
                                                                                    width: "100%",
                                                                                    borderRadius: "1px",
                                                                                    backgroundColor:
                                                                                        file.type === "PDF"
                                                                                            ? "#F14848"
                                                                                            : file.type === "PNG"
                                                                                                ? "#4881F1"
                                                                                                : file.type === "JPG"
                                                                                                    ? "#6A1B9A"
                                                                                                    : file.type === "GIF"
                                                                                                        ? "#F17048"
                                                                                                        : "#546E7A",
                                                                                    height: "13px",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                }}
                                                                            >
                                                                                {file.type}
                                                                            </Box>
                                                                        </Box>
                                                                        <Box>
                                                                            <Typography
                                                                                sx={{
                                                                                    fontWeight: 500,
                                                                                    fontSize: "14px",
                                                                                    color: "#324054",
                                                                                    lineHeight: "22px",
                                                                                    fontFamily: "Outfit, sans-serif",
                                                                                }}
                                                                            >
                                                                                File {file.name}
                                                                            </Typography>

                                                                            {/* File size or error */}
                                                                            {file.error ? (
                                                                                <Typography sx={{ fontWeight: 400, fontSize: "12px", color: "#F92828", lineHeight: "16px", letterSpacing: "-0.06px" }}>
                                                                                    {file.error}
                                                                                </Typography>
                                                                            ) : (
                                                                                <Typography
                                                                                    sx={{
                                                                                        fontWeight: 400,
                                                                                        fontSize: "12px",
                                                                                        color: "#71839B",
                                                                                        lineHeight: "16px",
                                                                                        fontFamily: "Outfit, sans-serif",
                                                                                        letterSpacing: "-0.06px",
                                                                                    }}
                                                                                >
                                                                                    {file.size}. {file.date}
                                                                                </Typography>
                                                                            )}

                                                                            {/* Upload progress */}
                                                                            {!file.error && file.status === "uploading" && (
                                                                                <Box sx={{ mt: 1 }}>
                                                                                    <LinearProgress
                                                                                        variant="determinate"
                                                                                        value={file.progress}
                                                                                        sx={{
                                                                                            height: 6,
                                                                                            width: 200,
                                                                                            borderRadius: "4px",
                                                                                            backgroundColor: "#E4ECF5",
                                                                                            "& .MuiLinearProgress-bar": {
                                                                                                backgroundColor: "#00B65E",
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                    <Typography
                                                                                        sx={{
                                                                                            fontWeight: 400,
                                                                                            fontSize: "12px",
                                                                                            color: "#71839B",
                                                                                            lineHeight: "16px",
                                                                                            fontFamily: "Outfit, sans-serif",
                                                                                            letterSpacing: "-0.06px",
                                                                                            mt: 0.5,
                                                                                            textAlign: "left",
                                                                                        }}
                                                                                    >
                                                                                        {file.progress}% Completed
                                                                                    </Typography>
                                                                                </Box>
                                                                            )}
                                                                        </Box>
                                                                    </Box>

                                                                    {/* Icons */}
                                                                    <Box sx={{ display: "flex", alignItems: "center", gap: "0.1px" }}>

                                                                        {file.status === "uploading" && (
                                                                            <IconButton onClick={() => handleRemoveFile(file.id)}>
                                                                                <LuX color="#71839B" size={15} />
                                                                            </IconButton>
                                                                        )}

                                                                        {file.status === "uploaded" && !file.error && (
                                                                            <>
                                                                                <IconButton>
                                                                                    <LuDownload color="#71839B" size={15} />
                                                                                </IconButton>
                                                                                <IconButton
                                                                                    onClick={() => handleRemoveFile(file.id)}
                                                                                >
                                                                                    <LuTrash2 color="red" size={15} />
                                                                                </IconButton>
                                                                            </>
                                                                        )}
                                                                    </Box>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    )}

                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        flexWrap: "wrap",
                                                        mt: "2px",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            flexGrow: 1,
                                                            color: "#726F86",
                                                            fontWeight: 400,
                                                            fontSize: "14px",
                                                            lineHeight: "100%",
                                                            fontFamily: "Outfit, sans-serif",
                                                        }}
                                                    >
                                                        Please review information before saving
                                                    </Typography>
                                                    <Button
                                                        onClick={onClose}
                                                        type="button"
                                                        sx={{
                                                            textTransform: "none",
                                                            color: "#F15744",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            lineHeight: "100%",
                                                            fontFamily: "Outfit, sans-serif",
                                                        }}>
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: "#00344C",
                                                            borderRadius: "25px",
                                                            textTransform: "none",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            lineHeight: "100%",
                                                            fontFamily: "Outfit, sans-serif",
                                                            color: "#FFFFFF",
                                                            px: "14px",
                                                            py: "8px",
                                                        }}
                                                    >
                                                        Save issue
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </DialogContent>
                        </form>
                    </Dialog>
                </Box>
            </Box>
        </Box>
    );
}

export default EditIssues;